const clerk = require("@clerk/clerk-react");

const {
  ClerkProvider,
  OrganizationSwitcher,
  SignIn,
  SignUp,
  SignOutButton,
  SignedIn,
  SignedOut,
  UserProfile,
  useAuth,
  useUser,
  useOrganizationList
} = clerk;

export {
  ClerkProvider,
  OrganizationSwitcher,
  SignIn,
  SignUp,
  SignOutButton,
  SignedIn,
  SignedOut,
  UserProfile,
  useAuth,
  useUser,
  useOrganizationList
};
